export const GET_IMG_SEGMENT_RUN_DATA='GET_IMG_SEGMENT_RUN_DATA';
export const GET_IMG_SEGMENT_RUN_DATA_ERROR='GET_IMG_SEGMENT_RUN_DATA_ERROR';
export const GET_IMG_SEGMENT_QUESTION_DATA='GET_IMG_SEGMENT_QUESTION_DATA';
export const GET_IMG_SEGMENT_QUESTION_DATA_ERROR='GET_IMG_SEGMENT_QUESTION_DATA_ERROR';
export const GET_IMG_SEGMENT_DATASET_DATA='GET_IMG_SEGMENT_DATASET_DATA';
export const GET_IMG_SEGMENT_DATASET_DATA_ERROR='GET_IMG_SEGMENT_DATASET_DATA_ERROR';
export const TRIGGER_IMG_SEGMENT_INSTANT_RESULT='TRIGGER_IMG_SEGMENT_INSTANT_RESULT';
export const TRIGGER_IMG_SEGMENT_INSTANT_RESULT_ERROR='TRIGGER_IMG_SEGMENT_INSTANT_RESULT_ERROR';


// WEBPACK FOOTER //
// ./src/redux/imgSegment/actionTypes.js